import React from 'react';

interface PaymentStatusBadgeProps {
  paymentStatus?: 'current' | 'due_soon' | 'overdue' | 'suspended' | string;
  daysOverdue?: number;
}

export function PaymentStatusBadge({ paymentStatus, daysOverdue = 0 }: PaymentStatusBadgeProps) {
  const status = (paymentStatus || 'current') as string;
  const defaultBadge = {
    label: '✓ Al día',
    className: 'bg-green-100 text-green-800 border-green-200',
  };
  const badges: Record<string, { label: string; className: string }> = {
    current: defaultBadge,
    due_soon: {
      label: '⏰ Vence pronto',
      className: 'bg-yellow-100 text-yellow-800 border-yellow-200',
    },
    overdue: {
      label: `⚠️ Vencido ${daysOverdue > 0 ? `${daysOverdue}d` : ''}`.trim(),
      className: 'bg-red-100 text-red-800 border-red-200',
    },
    suspended: {
      label: '🚫 Suspendido',
      className: 'bg-gray-100 text-gray-800 border-gray-200',
    },
  };
  const badge = badges[status] ?? defaultBadge;
  return (
    <span
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium border ${badge.className}`}
    >
      {badge.label}
    </span>
  );
}
